import CancellableHelper from "@/requests/CancellableHelper";
import { GetRequestsForPaymentListResponse } from "@/models/api/finances/GetRequestsForPaymentListItem";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import GenerateOverdueDocumentRequest from "@/models/api/finances/GenerateOverdueDocumentRequest";
import GetContractorForRequestForPaymentResponse from "@/models/api/finances/GetContractorForRequestForPaymentResponse";
import { axiosInstance } from "@/plugins/axios";

export const URL_GET_FINANCES_OVERDUE_PAYMENTS_DOCUMENTS = "/payment/OverdueDocuments/Paged";
export const URL_GET_CONTRACTOR_FOR_REQUEST_FOR_PAYMENT = "/contractor/${ContractorId}/RequestForPayment";
export const URL_GET_SHOW_REQUEST_FOR_PAYMENT = "/document/${DocumentId}/ShowRequestForPayment";
export const URL_POST_REMOVE_DOCUMENT = "/document/${DocumentId}/Remove";
export const URL_POST_GENERATE_OVERDUE_DOCUMENT = "/payment/GenerateOverdueDocument";

const _getOverduePaymentDocumentTable = new CancellableHelper<GetRequestsForPaymentListResponse>(
  URL_GET_FINANCES_OVERDUE_PAYMENTS_DOCUMENTS,
  GetRequestsForPaymentListResponse
);
_getOverduePaymentDocumentTable.jsonSerializer = true;
export const getOverduePaymentsDocumentsTable = async (
  genericTableRequest: GenericTableRequest
): Promise<GetRequestsForPaymentListResponse> => {
  return await _getOverduePaymentDocumentTable.get(genericTableRequest);
};

const _postGenerateOverdueDocument = new CancellableHelper<string>(URL_POST_GENERATE_OVERDUE_DOCUMENT, "string");
export const postGenerateOverdueDocument = async (request: GenerateOverdueDocumentRequest): Promise<string> => {
  return await _postGenerateOverdueDocument.post({}, request);
};

const _getContractorForRequestForPayment = new CancellableHelper<GetContractorForRequestForPaymentResponse>(
  URL_GET_CONTRACTOR_FOR_REQUEST_FOR_PAYMENT,
  GetContractorForRequestForPaymentResponse
);
export const getContractorForRequestForPayment = async (
  contractorId: string
): Promise<GetContractorForRequestForPaymentResponse> => {
  return await _getContractorForRequestForPayment.get({ ContractorId: contractorId });
};

export const showRequestForPayment = async (documentId: string): Promise<void> => {
  const response = await axiosInstance.get(
    URL_GET_SHOW_REQUEST_FOR_PAYMENT.replace("${DocumentId}", documentId.toString()),
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.click();
};

const _postRemoveDocument = new CancellableHelper<void>(URL_POST_REMOVE_DOCUMENT);
export const postRemoveDocument = async (documentId: string): Promise<void> => {
  return await _postRemoveDocument.post({ DocumentId: documentId }, null);
};
